export default {
  size: {
    label: 'Default paper size',
    tooltip: 'Defines the paper size that is always preselected.',
  },
  language: {
    label: 'Language',
    tooltip: 'Reports show the texts of their blocks, dates and numbers in this language. Names and other texts users enter stay as they are.',
  },
  showTimezone: {
    label: 'Show timezone',
    tooltip: 'Dates and times in reports name their timezone, e.g. CET. Turn it off if all your sites share one timezone',
  },
  header: {
    height: {
      tooltip: 'Defines the header height used on every report page.',
    },
    contentLeft: {
      tooltip: 'Defines the left header text shown on every report page.',
    },
    contentCenter: {
      tooltip: 'Defines the centered header text shown on every report page.',
    },
    contentRight: {
      tooltip: 'Defines the right header text shown on every report page.',
    },
  },
  footer: {
    contentLeft: {
      tooltip: 'Defines the left footer text shown on every report page.',
    },
    contentCenter: {
      tooltip: 'Defines the centered footer text shown on every report page.',
    },
    contentRight: {
      tooltip: 'Defines the right footer text shown on every report page.',
    },
  },
};
